import { Component, Input, OnInit } from '@angular/core';
import { EcommerceService } from '../service/ecommerce.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input('productLength') productLength: any;
  cartDatas = [];
  cartLenght : any = 0;
  constructor( private ecommerceService : EcommerceService ) { }
  
  ngOnInit() {
    console.log('productLength', this.productLength);
    this.cartLenght = this.productLength;
   /* this.showData();
    console.log("HEAD", this.cartDatas.length);
    this.cartLenght = this.cartDatas.length;*/
 }
 showData() {
   /* this.cartDatas = this.ecommerceService.showToCard();
    console.log('rafeeq', this.cartDatas);*/
 }

 ngOnChanges(){
  console.log('productLength', this.productLength);
  this.cartLenght = this.productLength;
 }

}
